'use client';

import { Copy } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';

interface CopyButtonProps {
  text: string;
  className?: string;
  iconClassName?: string;
  showOnHover?: boolean;
  title?: string;
  successMessage?: string;
}

export function CopyButton({
  text,
  className,
  iconClassName,
  showOnHover = true,
  title = 'Copy',
  successMessage,
}: CopyButtonProps) {
  const { toast } = useToast();

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      toast({
        title: successMessage || 'Copied to clipboard',
        duration: 2000,
      });
    } catch {
      toast({
        variant: 'destructive',
        title: 'Failed to copy',
        description: 'Please try again',
      });
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={cn(
        'transition-opacity p-0.5 hover:bg-muted rounded cursor-pointer',
        showOnHover && 'opacity-0 group-hover:opacity-100',
        className
      )}
      title={title}
      type="button"
    >
      <Copy className={cn('text-muted-foreground hover:text-foreground', iconClassName)} />
    </button>
  );
}

